import { definePreset } from '@primeuix/themes';
import Material from '@primeuix/themes/material';

const customPreset = definePreset(Material, {
    semantic: {
        primary: {
            50: '#F3F9FB',
            100: '#E0F7EA',
            200: '#C7EBD1',
            300: '#36B35A',
            400: '#1A7A36',
            500: '#229343',
            600: '#0D5C24',
            700: '#0B4B1E',
            800: '#083816',
            900: '#062911',
            950: '#03160A'
        },
        secondary: {
            50: '#F2F6CC',
            100: '#E9F1A4',
            200: '#E1EF62',
            300: '#C0E616',
            400: '#85B405',
            500: '#D7E649',
            600: '#7F9B00',
            700: '#627A00',
            800: '#495C00',
            900: '#333F00',
            950: '#1E2300',
        },
        success: {
            50: '#F0FDF0',
            100: '#E1FCDC',
            200: '#CCF7BB',
            300: '#45A636',
            400: '#2D7804',
            500: '#065F18',
            600: '#064E0B',
            700: '#053F09',
            800: '#032E07',
            900: '#021F04',
            950: '#011102',
        },
        info: {
            50: '#F0F9FF',
            100: '#E0F2FE',
            200: '#BAE6FD',
            300: '#0EA5E9',
            400: '#0577B4',
            500: '#0C4A6E',
            600: '#082F49',
            700: '#07263A',
            800: '#051C2B',
            900: '#04141F',
            950: '#020A10',
        },
        warn: {
            50: '#FFFBEB',
            100: '#FEF3C7',
            200: '#FDE68A',
            300: '#F59E0B',
            400: '#92400E',
            500: '#78350F',
            600: '#451A03',
            700: '#361403',
            800: '#260E02',
            900: '#180801',
            950: '#0C0400',
        },
        danger: {
            50: '#FEF2F2',
            100: '#FEE2E2',
            200: '#FECACA',
            300: '#DC2626',
            400: '#991B1B',
            500: '#7F1D1D',
            600: '#450A0A',
            700: '#360808',
            800: '#270606',
            900: '#180404',
            950: '#0C0202',
        },
        help: {
            50: '#e0f0ff',
            100: '#b3d9ff',
            200: '#80bfff',
            300: '#4da6ff',
            400: '#1a8cff',
            500: '#007acc',
            600: '#0066b3',
            700: '#004d80',
            800: '#00334d',
            900: '#001a26',
            950: '#000d13'
        },
        contrast: {
            50: '#000000',
            100: '#1a1a1a',
            200: '#333333',
            300: '#4d4d4d',
            400: '#808080',
            500: '#ffffff',
            600: '#f2f2f2',
            700: '#e6e6e6',
            800: '#d9d9d9',
            900: '#cccccc',
            950: '#bfbfbf'
        },
        //custom palettes
        complementary: {

            //add complementary colors

        },
        //add custom palettes
        colorScheme: {
            light: {
                primary: {
                    color: '#229343',       // primary.500
                    inverseColor: '#ffffff',
                    hoverColor: '#36B35A',  // primary.300
                    activeColor: '#1A7A36'  // primary.400
                },
                secondary: {
                    color: '#D7E649',       // secondary.500
                    background: '#E9F1A4',  // secondary.100
                    border: '#C7EBD1'       // secondary.200
                },
                success: {
                    color: '#065F18',       // success.500
                    background: '#CCF7BB',  // success.200
                    border: '#45A636'       // success.300
                },
                info: {
                    color: '#0C4A6E',       // info.500
                    background: '#BAE6FD',  // info.200
                    border: '#0EA5E9'       // info.300
                },
                warn: {
                    color: '#78350F',       // warn.500
                    background: '#FDE68A',  // warn.200
                    border: '#F59E0B'       // warn.300
                },
                danger: {
                    color: '#7F1D1D',       // danger.500
                    background: '#FECACA',  // danger.200
                    border: '#DC2626'       // danger.300
                },
                help: {
                    color: '#007acc',       // help.500
                    background: '#80bfff',  // help.200
                    border: '#1a8cff'       // help.400
                },
                highlight: {
                    background: 'rgba(0,0,0,.04)',
                    focusBackground: 'rgba(0,0,0,.08)',
                    color: 'rgba(0,0,0,.87)',
                    focusColor: 'rgba(0,0,0,.87)'
                },
                surface: {
                    0: '#ffffff',
                    50: '#f9f9f9',
                    100: '#f2f2f2',
                    200: '#F3F4F6',
                    300: '#E5E7EB',
                    400: '#D1D5DB',
                    500: '#9CA3AF',
                    600: '#6B7280',
                    700: '#4B5563',
                    800: '#1F2937',
                    900: '#111827',
                    950: '#000000',
                }
            }
        }
    },

});

export default customPreset;